import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'
import whiteList from './config/whitelist'
import { TokenModel } from '@/config/tokenModel'
import { kl_store } from './plugins/store'
let store: any = new kl_store();
// 查看url中是否携带token
const getQueryString = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  if (window.location.href.indexOf('?') < 0) {
    return null
  }
  const r = window.location.href.split('?')[1].match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}
let kong_access_token = getQueryString('kong_token')
let query_access_token = getQueryString('access_token')

const setToken = () => {
  if (window.androidWebObject) {
    // Lite APP 单独处理
    try {
      kong_access_token = window.androidWebObject.obtainKongToken()
      query_access_token = window.androidWebObject.obtainAccessToken()
    } catch(err) {}
  }


  console.log("🚀 ~ setToken ~ kong_access_token:", kong_access_token)
  console.log("🚀 ~ setToken ~ query_access_token:", query_access_token)
  if (kong_access_token && query_access_token) {
    store.setKongToken(kong_access_token)
    store.setToken(query_access_token)
    store.setIsExLink(true) // 如果url中存在token证明是从外部跳转过来， isExLink 设置为true
  }
  
  if (!store.kong_access_token && localStorage.getItem(TokenModel.token_name)) store.setKongToken(localStorage.getItem(TokenModel.token_name))
}

router.beforeEach(async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
  setToken()

  if (store.kong_access_token && store.access_token) {
    if (to.path === '/login') {
      // If is logged in, redirect to the home page
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    let include = whiteList.some((item: any) => {
      return to.path.indexOf(item)
    })
    // 是否属于登录白名单route
    if (include) {
      next()
    } else {
      // Other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
    }
  }
})

